import { render, staticRenderFns } from "./StoperList.vue?vue&type=template&id=6b242345&scoped=true&"
import script from "./StoperList.vue?vue&type=script&lang=js&"
export * from "./StoperList.vue?vue&type=script&lang=js&"
import style0 from "./StoperList.vue?vue&type=style&index=0&id=6b242345&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b242345",
  null
  
)

export default component.exports